import React, { useContext, useState, useEffect, useMemo } from 'react';
import toast from 'react-hot-toast';

import { DataContext } from '../../init/getData';

import { Modal, Col, Form, Row, DropdownButton, Dropdown, InputGroup } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, Card, theme } from 'antd';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiExport } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcKindle, FcCancel, FcPlus } from "react-icons/fc";
import { FaCheck } from "react-icons/fa";
import { HiMinusCircle } from "react-icons/hi";

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import Loader from '../../components/loader/loader';
import LoadStockJv from './functions/loadStockJv';

import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';


import InvoiceInfo from './steps/invoiceInfo';
import InvoiceCart from './steps/invoiceCart';
import InvoiceJv from '../../components/journalVoucher/invoiceJv';

const StockForm = (props) => {

    const { api, userData, settingData, accountData, defaultCurrency, selectedCompany, currencyData,
        productData, refData, branchData, selectedYear, rateMainToSecondaryCurrency,
        rateToMainCurrency, formLanguages  } = useContext(DataContext);   



    const userId = userData.id;
    const userName = userData.name;
    const userRole = userData.role.name;
    const createdBy = parseInt(userData.id);
    const companyId = selectedCompany.id;
    const yearId = selectedYear.id;

    const { showModal, toggleModal, table, title, isOrder, idRow } = props;
    const [loadingEffect, setLoadingEffect] = useState(false);
    const [validated, setValidated] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [journalVoucher, setJournalVoucher] = useState({});
    const [cart, setCart] = useState([])
    const [transactions, setTransactions] = useState([])

    const selectedCurrency = useMemo(() => {
        return currencyData?.find(option => option.id === journalVoucher.currencyId);
    }, [currencyData, journalVoucher.currencyId]);


    const totalCost = cart.reduce((sum, currentItem) => sum + parseFloat(currentItem?.netCost * currentItem?.netQuantity), 0);

    const today = new Date().toISOString().split('T')[0];


    const cartItem = {
        accountId: '',
        index: 0,

        quantity: 1,
        netQuantity: 1,
        subQuantity: 1,

        cost: 0,
        netCost: 0,

        details: '',

        unitName: '',
        unitQuantity: '',

        productId: '',
    };


    // idRow Change
    useEffect(() => {

        if (!isLoading) {
            setCartAndUnits();
            setTransactions(idRow?.transactions || [])

            setJournalVoucher(
                {
                    createdBy: createdBy,
                    companyId: companyId,
                    yearId: yearId,
                    accountId: idRow?.accountId || null,
                    refNumber: idRow?.refNumber || '',
                    date: idRow?.date || today,
                    type: 'stockCount',
                    details: idRow?.details || '',
                    isDebit: true,
                    isOrder: false,
                    warehouseId: idRow?.warehouseId || null,
                    projectId: idRow?.projectId || null,
                    branchId: idRow?.branchId || null,
                    currencyId: idRow?.currencyId || defaultCurrency.id,
                    rate: idRow?.rate || defaultCurrency.rate,
                }
            )
        }
    }, [isLoading, idRow]);

    const setCartAndUnits = () => {
        const updatedCart = idRow?.cart ? [...idRow?.cart] : [];

        updatedCart?.forEach((item, index) => {
            const product = productData.find(e => e.id == item.productId);
            item.units = product?.units || [];
            item.stocks = product?.stocks || [];
        }
        )
        setCart(updatedCart || [cartItem])
    }



    // change totalDebit and totalCredit
    useEffect(() => {

        const totalDebit = rateToMainCurrency(selectedCurrency, totalCost);
        const totalCredit = rateToMainCurrency(selectedCurrency, totalCost);

        setJournalVoucher((prev) => ({
            ...prev,
            debit: totalCost,
            credit: totalCost,
            totalDebit: totalDebit,
            totalCredit: totalCredit,
            secondaryTotalCredit: rateMainToSecondaryCurrency(totalDebit),
            secondaryTotalDebit: rateMainToSecondaryCurrency(totalCredit),
        }));

    }, [totalCost]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setIsLoading(true);
                const dataArray = ['auxAccount', 'warehouse', 'project', 'currency', 'product', 'setting']
                await refData(dataArray, companyId);
                setIsLoading(false);
            } catch (error) {
                console.error('Error refreshing data Contact Support');
            }
        };
        if (showModal) {
            fetchData();
        }
    }, [showModal]);



    const handleSubmit = async (e) => {
        e.preventDefault();


        const form = document.getElementById('form');

        if (form.checkValidity() === false) {
            return;
        }


        setLoadingEffect(true);


        const data = {
            jvId: idRow?.id,
            transactions,
            journalVoucher,
            cart,
        }

        const operation = idRow ? 'edit' : 'add '
        try {
            let res = await api.post(`journalVoucher/${operation}`, data);

            if (res.data.status) {
                toast.success(res.data.message);
                closeModal();
            } else {
                toast.error(res.data.message);
            }
        } catch (error) {
            toast.error("Failed Contact Support");
        } finally {
            setLoadingEffect(false);
            setValidated(false);
        }
    }

    const closeModal = () => {
        toggleModal();
        setValidated(false);
        const form = document.getElementById('form');
        form.reset();
        setCart([cartItem]);
        setTransactions([]);
    }



    return (
        <>
            <Modal show={showModal} onHide={toggleModal} backdrop="static" fullscreen={true}>

                <Modal.Header style={{ background: "#23576a" }} closeButton>
                    <Modal.Title style={{ color: "white" }}>{idRow ? formLanguages.Edit : formLanguages.Add}{formLanguages.StockCount}</Modal.Title>
                </Modal.Header>

                <Form validated={validated} id={'form'} onSubmit={handleSubmit} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); } }} >
                    <Modal.Body className="custom-scrollbar" style={{ backgroundColor: '#f0f2f5', maxHeight: '75vh', overflowY: 'auto' }}>

                        <Row className="mb-4">
                            <Col>

                                <Card title={formLanguages.Details} bordered={false}>
                                    <InvoiceInfo
                                        journalVoucher={journalVoucher}
                                        setJournalVoucher={setJournalVoucher}
                                        validated={validated}
                                    />
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col>
                                <Card title={formLanguages.Products} bordered={false}>
                                    <InvoiceCart
                                        cart={cart}
                                        setCart={setCart}
                                        cartItem={cartItem}
                                        validated={validated}
                                        journalVoucher={journalVoucher}
                                    />
                                </Card>
                            </Col>
                        </Row>

                        <Row className="mb-4">
                            <Col>
                                <Card title={formLanguages.JournalVoucher} bordered={false}>
                                    <InvoiceJv
                                        transactions={transactions}
                                    />
                                </Card>
                            </Col>
                        </Row>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button type="primary" loading={loadingEffect} htmlType="submit"
                            onClick={() => setValidated(true)}
                            style={{ marginLeft: '10px', backgroundColor: '#1d7790' }}>{formLanguages.Save}</Button>
                    </Modal.Footer>


                </Form>
            </Modal >

            <LoadStockJv
                setTransactions={setTransactions}
                journalVoucher={journalVoucher}
                selectedCurrency={defaultCurrency}
                cart={cart}
                totalCost={totalCost}
            />
        </>
    )
}


export default StockForm;